Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'
activityFeedInfoTemplate = require 'views/templates/activity_feed_info'

module.exports = class BoardsPageActivityFeedInfoView extends View
  viewTitleKey: 'activity feed info'
  tagName: 'div'
  className: ''

  events:
    'click .js-disable-activity-feed': 'disableActivityFeed'

  render: ->
    @$el.html activityFeedInfoTemplate
      memberId: @options.memberId
    @

  disableActivityFeed: (e) ->
    Util.stop(e)
    Auth.me().dismiss('activityFeedExperiment')
    track('Boards View', 'Activity Feed', 'Clicked dismiss')
    PopOver.popView()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-activity-feed-info-view.coffee